var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrangeArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3 11.2758C9.1 11.0758 9.004 10.8341 9.012 10.5508C9.02 10.2674 9.12434 10.0258 9.325 9.82578L12.15 7.00078H1C0.71667 7.00078 0.479004 6.90478 0.287004 6.71278C0.0950036 6.52078 -0.000663206 6.28345 3.4602e-06 6.00078C3.4602e-06 5.71745 0.0960036 5.47978 0.288004 5.28778C0.480004 5.09578 0.717337 5.00011 1 5.00078H12.15L9.3 2.15078C9.1 1.95078 9 1.71311 9 1.43778C9 1.16245 9.1 0.925114 9.3 0.725781C9.5 0.525781 9.73767 0.425781 10.013 0.425781C10.2883 0.425781 10.5257 0.525781 10.725 0.725781L15.3 5.30078C15.4 5.40078 15.471 5.50911 15.513 5.62578C15.555 5.74245 15.5757 5.86745 15.575 6.00078C15.575 6.13411 15.554 6.25911 15.512 6.37578C15.47 6.49245 15.3993 6.60078 15.3 6.70078L10.7 11.3008C10.5167 11.4841 10.2877 11.5758 10.013 11.5758C9.73834 11.5758 9.50067 11.4758 9.3 11.2758Z",
    fill: "#FB512D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeArrowRight);
export default __webpack_public_path__ + "static/media/orangeArrowRight.134cdc2ea1059c9b37aa09298cf85428.svg";
export { ForwardRef as ReactComponent };